<template>
  <li v-bind:class="cryptoClass" v-bind:data-nb="priceInCurrency" @click="openLink">
    <div v-if="crypto.symbol">
      {{crypto.symbol}}
      <span>{{crypto.name}}</span>
    </div>
  </li>
</template>

<script>
export default {
  props: {
    crypto: Object,
    currency: String,
    currentClass: String
  },
  data() {
    return {
      priceInCurrency: null
    }
  },
  computed: {
    cryptoClass() {
      if (this.crypto.symbol) {
        if (this.currentClass && this.currentClass != this.crypto.class) {
          return [this.crypto.class, 'deactivate']
        } else {
          return this.crypto.class
        }
      } else {
        return 'empty'
      }
    },
    infoLink() {
      return `https://www.cryptocompare.com/coins/${this.crypto.symbol}/overview`
    }
  },
  watch: {
    currency() {
      this.fetchPrice()
    }
  },
  methods: {
    fetchPrice() {
      if (this.crypto.symbol) {
        const url = `https://min-api.cryptocompare.com/data/price?fsym=${this.crypto.symbol}&tsyms=${this.currency}`
        const formatter = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: this.currency,
          maximumSignificantDigits: 4
        });
        this.$http.get(url).then(response => {
          if (!isNaN(response.data[this.currency])) {
            this.priceInCurrency = formatter.format(response.data[this.currency]).replace(/BTC/,'Ƀ')
          }
        });
      }
    },
    openLink() {
      window.open(this.infoLink)
    }
  },
  mounted() {
    this.fetchPrice()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
